import { htmlToPlainText } from '../../sports/shared/templates/basicInfoTemplates';

/** Empty: undefined, only spaces, or HTML without visible text (e.g. `<p></p>`). */
export function isHtmlContentEmpty(html: string | undefined): boolean {
  if (html == null) return true;
  const text = htmlToPlainText(html);
  return text.length === 0;
}
